import { render } from "./TestInClassStudent.vue?vue&type=template&id=53b3e5e5&scoped=true"
import script from "./TestInClassStudent.vue?vue&type=script&lang=js"
export * from "./TestInClassStudent.vue?vue&type=script&lang=js"

import "./TestInClassStudent.vue?vue&type=style&index=0&id=53b3e5e5&scoped=true&lang=css"

import exportComponent from "/var/www/dt_project_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b3e5e5"]])

export default __exports__